<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          基本信息
        </div>
        <div class="info-content" style="padding-top:25px;">
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="通知标题   ">
                <a-input placeholder="请输入通知标题"  
                    v-decorator="[
                    'title',
                    {rules: [{ required: true, message: '请输入通知标题' }]},
                    {'initialValue':this.title}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="通知摘要   ">
                <a-textarea
                  style="height:80px;resize: none;"
                  placeholder="请输入通知摘要"
                  v-decorator="[
                    'msgBrief',
                    {rules: [{ required: true, message: '请输入通知摘要' }]},
                    {'initialValue':this.msgBrief}
                  ]" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="通知正文   ">
                <j-editor 
                v-decorator="[ 'msgContent', {} ,{'initialValue':this.msgContent}]" triggerChange></j-editor>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="a-row">
          <a-button
          style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
          type="primary"
          @click="announcementCreateOk()"
        >
          发送
        </a-button>

        <a-button
          style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;margin-left:30px"
          type="primary"
          @click="cancelPage()"
        >
          取消
        </a-button>
        </div>
      </a-card>

    </a-form>
  </div>
  
</template>

<script>

  import JEditor from '@/components/jeecg/JEditor'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"

  import {addAnnoucement,editAnnoucementbyId,queryAnnoucementbyId} from '@/api/api'

  import pick from 'lodash.pick'

  import _ from 'lodash'
import moment from 'moment'


  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'AnnouncementCreate',
    components: { JEditor},
    mixins: [],
    data() {
      return {
        id:"",
        title:"",//标题
        msgBrief:"", //消息摘要
        msgContent:"",//内容
        startTime:"",//开始时间
        endTime:"",//结束时间
       
        sender:"", //发布人
        priority:"",//优先级
        msgCategory:"1",//消息分类1：公告，2消息,3:模板消息
        msgType:"1",//对象类型-1：全员，2：个别
        sendStatus:"",//发布状态（0未发布，1已发布，2已撤销）
        form: this.$form.createForm(this),
      }
    },
    
    methods: {
      cancelPage(){
        window.history.go(-1);
      },
      
      handleCancel () {
        this.previewVisible = false
      },

      imgBeforeUpload (file) {
        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传图片!')
        }
       
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },
      
      announcementCreateOk(){
        this.form.validateFields((err, values) => {
          if (!err) {
            // let courseCoverFile = this.courseCoverFile;

            let valuesParam = {};
            valuesParam = {...values};

            let opFun = "";
            if(_.isEmpty(this.id)){
              opFun = addAnnoucement(valuesParam);
            }else{
              valuesParam = {...valuesParam,id:this.goodsId}
              opFun = editAnnoucementbyId(valuesParam)  
            }

            opFun.then((res)=>{
              if(res.success==true){
                this.$message.success(res.message,()=>{
                  this.$router.push({ path:'/operationsManagement/notificationManagement'});
                });
                
              }else{
                this.$message.warning(res.message);
              }

            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })


          }
        })
      },
      
    },
    
    created () {
      // const token = Vue.ls.get(ACCESS_TOKEN);
      // this.headers = {"X-Access-Token":token}

      // this.goodsId = this.$route.query.goodsId;
      // if(!_.isEmpty(this.goodsId)){
      //   queryGoodsById({id:this.goodsId}).then((res)=>{
      //     if(res.code==0){
      //       console.log(res)
      //       let resultData = res.result;

            


      //       this.goodsPicUrl = resultData.goodsPicUrl?resultData.goodsPicUrl:"";
      //       this.sellMode = resultData.sellMode?resultData.sellMode:"";

      //       this.$nextTick(() => {
      //         this.form.setFieldsValue(pick(resultData,'goodsName','goodsDesc',
      //         'goodsBrief','categoryId','sellMode','marketPrice','price','goodsPicUrl'))

      //       });


      //     }else{
      //       this.$message.warning(res.message);
      //     }

      //   }).finally(() => {
      //     // that.confirmLoading = false;
      //     // that.checkedDepartNames = [];
      //     // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

      //     // that.close();
      //   })
      // }else{
      //   this.$nextTick(() => {
      //     this.form.setFieldsValue({sellMode:this.sellMode});
      //   });
      // }
      
    },
    computed:{
      uploadAction:function () {
        return this.url.fileUpload;
      }
    },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
  .course-create-wrap{
    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    } 

    .info-content{
      .img-tip{
        color: #999999;
        font-size: 12px;
      }
      .ant-upload-list-picture-card{
        .ant-upload-list-item{
          width:142px!important;
          height:80px;
        }
      }
      .j-teacher-list{
        .j-teacher-item{
          
          
          .j-teacher-item-con{
            width: 587px;
            padding: 20px;
            overflow: hidden;
            border: 1px solid #D0DBE4;
            display: inline-block;
            vertical-align: middle;
            .j-teacher-item-upload{
              width: 90px;
              float: left;
              .ant-upload-select-picture-card{
                width: 80px;
                height:80px;
              }
            }
            .j-teacher-item-ctx{
              margin-left:90px;
              
            }
            
          }
          .j-teacher-item-cz{
            display: inline-block;
            vertical-align: middle;
            margin-left: 35px;
            color: #0091FF;
            cursor: pointer;
          }
          
        }
      }
      .kaike-tip{
        color:#FA6400;
        font-size: 12px;
        // line-height: 1;
      }
      .kaike-radio-list{
        line-height: 1;
        .kaike-radio-item{
          line-height: 1;
          margin-bottom: 12px;
          margin-top: 0px;
        }
      }
      
    }

    
  }
  

</style>